import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as MediaActions from "../../data/media/MediaActions";

import { TrashIcon, DownloadIcon } from "@heroicons/react/solid";
import ModalConfirm from "UI/ModalConfirm";
import Dropdown from "UI/Dropdown";
import Feature from "Components/Feature";

class MediaCardSettingsMenu extends React.Component
{
    state = {
        dialog: null
    };

    static propTypes = {
        file: PropTypes.object.isRequired,
        onDelete: PropTypes.func.isRequired,
        onDownload: PropTypes.func.isRequired,
    };

    render()
    {
        return <>
            <Dropdown button={Dropdown.VerticalDotsButton} origin='tl'>
                <Dropdown.Item onClick={this.props.onDownload}>
                    <DownloadIcon className='h-4 w-auto' aria-hidden="true" />
                    <span>Download</span>
                </Dropdown.Item>
                <Dropdown.Item danger onClick={() => this.setState({dialog: 'delete'})}>
                    <TrashIcon className='h-4 w-auto' aria-hidden="true" />
                    <span>Delete</span>
                </Dropdown.Item>
            </Dropdown>

            <ModalConfirm
                danger
                open={this.state.dialog === 'delete'}
                onConfirm={() => this.props.onDelete().then(() => this.setState({dialog: null}))}
                onClose={() => this.setState({dialog: null})}
            >
                Are you sure you wish to remove this file?
            </ModalConfirm>
        </>;
    }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onDelete: () => dispatch(MediaActions.removeMedia(ownProps.file.id)),
    onDownload: () => dispatch(MediaActions.downloadMedia(ownProps.file.id))
});

export default connect(
    null,
    mapDispatchToProps
)(MediaCardSettingsMenu);
